import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TypeformPayloadState {
  data: TypeformPayload;
  isLoading: boolean;
  error: string | null;
}

const initialState: TypeformPayloadState = {
  data: null,
  isLoading: false,
  error: null,
};

export type FetchTypeformPayloadByClientId = {
  clientId: string;
};

const typeformSlice = createSlice({
  name: 'typeformPayload',
  initialState,
  reducers: {
    fetchTypeformPayloadByClientIdRequest(state, action: PayloadAction<FetchTypeformPayloadByClientId>) {
      state.isLoading = true;
      state.error = null;
    },
    // State updates
      fetchTypeformPayloadByClientIdResponse(
        state,
        action: PayloadAction<TypeformPayload>
      ) {
        state.data = action.payload;
        state.isLoading = false;
        state.error = null;
      },
      fetchTypeformPayloadByClientIdFailure(state, action) {
        state.isLoading = false;
        state.error = action.payload?.message || 'Failed to fetch typeform payload';
      },
      resetTypeformPayloadState(state) {
        state.data = initialState.data;
        state.isLoading = initialState.isLoading;
        state.error = initialState.error;
      },
  },
});

export const {
  fetchTypeformPayloadByClientIdRequest,
  fetchTypeformPayloadByClientIdResponse,
  fetchTypeformPayloadByClientIdFailure,
  resetTypeformPayloadState,
} = typeformSlice.actions;

export const typeformPayloadReducer = typeformSlice.reducer;